import { Col } from 'reactstrap';

import { Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import SectionTitle from '../../../../../../components/Text/SectionTitle';
import StudentCurriculumProgress from '../academicHistorytabs/Curriculum/parts/StudentCurriculumProgress';
import { StudyPlanEnrollmentsInfo } from '../../../../studentFileList/types';
import { TranslationsKeys } from '../../../../../../locales/translations';

interface CurriculumInfoProps {
  studyPlanEnrollmentId: string | undefined;
  studyPlanEnrollmentsInfo: StudyPlanEnrollmentsInfo[];
}

export default function CurriculumInfo({
  studyPlanEnrollmentId,
  studyPlanEnrollmentsInfo,
}: CurriculumInfoProps) {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_ACADEMIC_HISTORY);

  const curricularProgress = useMemo(() => {
    return studyPlanEnrollmentsInfo.find(
      (studyPlanEnrollment) =>
        studyPlanEnrollment.studyPlanEnrollmentId ===
        Number(studyPlanEnrollmentId),
    );
  }, [studyPlanEnrollmentId, studyPlanEnrollmentsInfo]);

  return (
    <Col className="mt-2">
      <Row>
        <SectionTitle text={t(`title`)} />
        <p className="text-medium fs-16 mt-3 mb-4">{t(`description`)}</p>
      </Row>
      <Row>
        <StudentCurriculumProgress
          studyPlanEnrollmentId={Number(studyPlanEnrollmentId)}
          curriculumProgressAvg={curricularProgress?.progressAverage ?? null}
          texts={{
            CurriculumProgressTooltip: t(
              `curriculumProgressStudent.curriculumProgressTooltip`,
            ),
            CurriculumProgress: t(
              `curriculumProgressStudent.curriculumProgress`,
            ),
          }}
        />
      </Row>
    </Col>
  );
}
